import { z } from "zod";
const id = z.string().regex(/^[0-9A-HJKMNP-TV-Z]{26}$/iu);
const digest = z.string().regex(/^[a-f0-9]{64}$/u);
/** Closing a settled failure never generates content, refunds usage, or approves a picture. */
export const closeStoryVisualFailureCommandSchema = z
    .object({
    action: z.literal("CLOSE_FAILED_VISUAL_DISCOVERY"),
    jobId: id,
    expectedStoryRevision: z.number().int().nonnegative(),
    expectedIntentRevision: z.number().int().positive(),
    expectedVisualRevision: z.number().int().nonnegative(),
    reviewDigestSha256: digest,
})
    .strict();
export const storyVisualFailureRecoveryOfferSchema = z
    .object({
    version: z.literal("STORY_VISUAL_FAILURE_RECOVERY_V1"),
    bookId: id,
    jobId: id,
    recordedCostMicros: z.number().int().nonnegative(),
    historyPreserved: z.literal(true),
    providerDispatchAuthorized: z.literal(false),
    command: closeStoryVisualFailureCommandSchema,
})
    .strict()
    .superRefine((offer, context) => {
    if (offer.jobId !== offer.command.jobId)
        context.addIssue({ code: "custom", path: ["command", "jobId"], message: "Job must match." });
});
export const storyVisualFailureRecoveryReceiptSchema = z
    .object({
    version: z.literal("STORY_VISUAL_FAILURE_RECOVERY_V1"),
    bookId: id,
    jobId: id,
    recordedCostMicros: z.number().int().nonnegative(),
    reviewDigestSha256: digest,
    closedBy: id,
    closedAt: z.string().datetime(),
    historyPreserved: z.literal(true),
    budgetChanged: z.literal(false),
    providerDispatchAuthorized: z.literal(false),
})
    .strict();
//# sourceMappingURL=story-visual-failure-recovery.js.map